'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const DEFAULT_COLUMN_TYPES = ['title', 'events'];
export const TimelineGridRootContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") TimelineGridRootContext.displayName = "TimelineGridRootContext";
export function useTimelineGridRootContext() {
  const context = React.useContext(TimelineGridRootContext);
  if (context === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: TimelineGridRootContext is missing. ' + 'TimelineGrid parts must be placed within <TimelineGrid.Root />.' : _formatErrorMessage(267));
  }
  return context;
}